export default [
	{
		id: 1,
		type: "text",
		title: "Persönliche Angaben",
		items: [
			{
				id: 1,
				type: "small",
				text: "Semester",
			},
			{
				id: 2,
				type: "medium",
				text: "Studiengang",
			},
		],
	},
	{
		id: 2,
		type: "matwis-p",
		title: "Wie bewerten Sie diese Veranstaltung (in Schulnoten)?",
		rowTitle: "Praktikumsversuch",
		items: [
			{
				id: 3,
				text: "REM: Channeling und Verformungsmessung (Motz, Betreuer/in: Jonas Rauber)",
			},
			{
				id: 4,
				text: "Rastersondenmikroskopie (Motz, Betreuer/in: Dr. Florian Schäfer)",
			},
			{
				id: 5,
				text: "Betriebsfestigkeit (Motz, Betreuer/in: Dr. Florian Schäfer)",
			},
			{
				id: 6,
				text: "Werkstoffentwicklung (Busch, Betreuer/in: Amir Ghavimi, Maryam Rahimi)",
			},
			{
				id: 7,
				text: "Werkstoffcharakterisierung (Busch, Betreuer/in: Amir Ghavimi, Maryam Rahimi)",
			},
			{
				id: 8,
				text: "Untersuchungen zum dynamischen Verhalten beim Honen (Bähre, Betreuer/in: Murat Güner)",
			},
			{
				id: 9,
				text: "Lasersintern von Kieselglasgrünkörpern (Falk, Betreuer/in: Laura Krämer)",
			},
			{
				id: 10,
				text: "Microstructural segmentation and quantitative image analysis (Mücklich, Betreuer/in: Pranav Nayak)",
			},
			{
				id: 11,
				text: "Schadensanalyse (Mücklich, Betreuer/in: Adrian Thome)",
			},
			{
				id: 12,
				text: "Electrical Contact Resistance Measurement (Mücklich, Betreuer/in: Bruno Alderete)",
			},
			{
				id: 13,
				text: "Thermische Charakterisierung von Polymeren (Lienkamp, Betreuer/in: Swati Sharma)",
			},
			{
				id: 14,
				text: "Radikalische Polymerisation und Polymercharakterisierung  (Lienkamp, Betreuer/in: Swati Sharma, Katrin Glücks)",
			},
			{
				id: 15,
				text: "Herstellung und Charakterisierung von Polymerfilmen  (Lienkamp, Betreuer/in: Swati Sharma, Marc Thiel)",
			},
			{
				id: 16,
				text:
					"Solid or fluid? Key concepts of rheology applied to materials” / ”Fest oder flüssig? Grundkonzepte der Rheologie angewandt auf Materialien (Gonzales-Garcia, Betreuer/in: Dominik Schmidt)",
			},
			{
				id: 17,
				text: "Printing of metal based conductive pastes for flexible and recyclable electronics (Gonzales-Garcia, Betreuer/in: David Van Impelen)",
			},
		],
	},
	{
		id: 3,
		type: "text",
		items: [
			{
				id: 18,
				text: 'Gerne können Sie auch Lob und Kritik angeben. Insbesondere falls Sie "Sehr gut" oder "Mangelhaft" angekreuzt haben, würde uns der Grund interessieren:',
			},
		],
	},
];
